import { SetStateAction, useContext, useEffect } from 'react'
import { setValueSmoothly } from '../../../functions/setValueSmoothly'
import { InternalContext } from '../../contexts/InternalContext'

let animation: {
  targetValue: number
  cancel: () => void
} | null = null

export function useSetZoomSmoothly(predicate: SetStateAction<number>) {
  const { zoom, setZoom } = useContext(InternalContext)

  useEffect(() => {
    return () => {
      animation?.cancel()
    }
  }, [])

  return () => {
    animation?.cancel()

    const targetValue = typeof predicate === 'function' ? predicate(animation?.targetValue || zoom) : predicate

    animation = {
      targetValue,
      cancel: setValueSmoothly({
        from: zoom,
        to: targetValue,
        setValue: setZoom,
        onEnd: () => {
          animation = null
        },
      }),
    }
  }
}
